import { Breakpoint } from '@altibox/design-system-component-lib';
// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/design-system-component-lib/dist/components/typography/types';
import React, { FC } from 'react';

import { StyledOrderedListElement } from './ordered-list-element.styled';

type Props = Omit<TypographyProps, 'component'>;

export const OrderedListElement: FC<Props> = (props) => {
  const { maxBreakpoint = Breakpoint.TABLET, ...rest } = props;

  return <StyledOrderedListElement {...rest} component="li" maxBreakpoint={maxBreakpoint} />;
};
